import {ILayoutService} from "./layout.service.interface";
import {ServiceBase} from "../service-base";
import {IServiceFactory} from "../service-factory.interface";
import {LayoutDetection} from "./layout-detection";
import {RawLocalStorageKeys} from "../storage/raw-local-storage/raw-local-storage-keys";



export class LayoutService extends ServiceBase implements ILayoutService {

    constructor(services: IServiceFactory) {
        super(services);
        this._layoutDetection = new LayoutDetection();
    }

    private readonly _layoutDetection: LayoutDetection;

    get shouldUseWebappLayout(): boolean {
        return this._layoutDetection.shouldUseWebappLayout;
    }

    switchLayoutMode(): void {
        if(this.shouldUseWebappLayout) {
            this.services.rawLocalStorage.setItem(RawLocalStorageKeys.forceHybridLayout, 'true');
        } else {
            this.services.rawLocalStorage.setItem(RawLocalStorageKeys.forceHybridLayout, 'false');
        }

        this.services.window.reload();
    }



}
